// @flow
import {render} from "./render";
import {effortless} from "./effortless";

type TWithParams = {
	template: string,
	selector: string,
}


//go! with-router
const createClass = (Class, args) => {
	let instance = null;

	try {
		instance = new Class(...args);
	} catch (e) {
		console.log("[with-renderer] Constructor is invalid");
		throw e;
	}

	return instance;
};

const withRenderer = (params: TWithParams) => (Constructor: Function) => (...classArgs: any[]) => {
	const createdClass = createClass(Constructor, classArgs);

	effortless(() => (
		render({
			model: createdClass,
			...params,
		}))
	);


	return createdClass;
};


export {
	withRenderer,
};
